import { errorAlert } from 'cadenza/alert';
import type { Authority } from 'cadenza/api-client/srs-api';
import { hasMaxExtent } from 'cadenza/api-client/srs-api';
import { Command } from 'cadenza/api-client/workbook-commands';
import { fetchConfigurations, getConfiguration } from 'cadenza/config/configuration';
import { getStore } from 'cadenza/store/cadenza-store';
import { executeCommand } from 'cadenza/workbook/workbook-core-reducers.state';
import { getActiveWorksheetId } from 'cadenza/workbook/workbook-core-selectors.state';

import i18n from './add-empty-map-view.properties';

export async function addEmptyMapView() {
  const worksheetId = getActiveWorksheetId(getStore().getState());

  await fetchConfigurations(['map']);

  const availableSrs = getConfiguration('map').availableSrs;

  if (!availableSrs.length) {
    return;
  }

  let selectedSrsCode: Authority;

  if (availableSrs.length > 1) {
    const { EmptyMapViewCreationDialog } = await import(
      'cadenza/workbook/empty-map-view-creation/empty-map-view-creation-dialog'
    );
    selectedSrsCode = await new EmptyMapViewCreationDialog().connectAndShow();
  } else {
    selectedSrsCode = availableSrs[0].authority;
  }

  if (await hasMaxExtent(selectedSrsCode)) {
    getStore().dispatch(executeCommand(Command.ADD_EMPTY_MAP_VIEW({ worksheetId, srsCode: selectedSrsCode })));
  } else {
    errorAlert(i18n('missingMaxExtent.error.title'), i18n('missingMaxExtent.error.message'));
  }
}
